<script setup>
import CookieNotice from "@/Components/CookieNotice.vue";
import Footer from '@/Components/Footer/Footer.vue';
import Header from '@/Components/Header/Header.vue';
import Notifications from '@/Components/Notifications.vue';
import {useCart} from '@/stores/cart';
import whatsapp from '@i/whatsapp.svg';
import {Head, usePage,} from '@inertiajs/vue3';
import {watch} from 'vue';


defineProps({
  title: String,
  description: String,
});

const cart = useCart();
cart.load(usePage().props.shoppingCart);

watch(
    () => usePage().props.shoppingCart,
    (shoppingCart) => useCart().load(shoppingCart)
);


</script>

<template>
    <Head>
        <title>{{ title }}</title>
        <meta
            :content="description"
            head-key="description"
            name="description"
        >
    </Head>
    <div class="relative flex min-h-screen flex-col">
        <!-- Page Header -->
        <Header />
        <div class="min-h-35 lg:min-h-40" />

        <!-- / Page Header -->

        <Notifications />

        <!-- Page Content -->
        <main>
            <slot />
        </main>
        <!-- / Page Content -->

        <Footer />

        <CookieNotice />

        <div class="pointer-events-none fixed bottom-40 w-full">
            <div class="container pointer-events-none flex w-full justify-end">
                <a
                    class="pointer-events-auto z-50 rounded bg-primary p-4"
                    href="https://api.whatsapp.com/send/?phone=31639897340&text&type=phone_number&app_absent=0"
                >
                    <img
                        :src="whatsapp"
                        alt="whatsapp"
                        class="size-10"
                    >
                </a>
            </div>
        </div>
    </div>
</template>
